import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Book, CheckCircle2 } from 'lucide-react';
export function TomosSection() {
  const tomos = [{
    id: 1,
    color: 'blue',
    title: 'Fundamentos, Gramática y Fonética',
    subtitle: 'El código del idioma para el argentino',
    content: 'Abecedario inglés para hispanohablantes, el sonido TH, la R británica, frases de cortesía obligatorias, estructura mínima de oraciones, bloques I WANT / I NEED / WHERE IS, números, dinero en libras, horas, días y meses, vocabulario de aeropuerto y hotel.'
  }, {
    id: 2,
    color: 'green',
    title: 'El Día a Día',
    subtitle: 'Del Tube a Oxford Street',
    content: 'Cómo usar el Tube y el bus sin pánico, la Oyster Card, cómo pedir en un pub como un local, frases para restaurantes y cafeterías, check-in y resolución de problemas en el hotel, vocabulario de compras y talles británicos.'
  }, {
    id: 3,
    color: 'orange',
    title: 'Situaciones y Emergencias',
    subtitle: 'Qué decir cuando las cosas salen mal',
    content: 'Farmacia y equivalencias de remedios argentinos vs UK, cómo explicar síntomas al médico, el sistema de salud NHS, qué hacer si te roban, protocolo ante pérdida del pasaporte, equipaje perdido, vuelos cancelados y situaciones sin celular.'
  }, {
    id: 4,
    color: 'red',
    title: 'La Guía Anti-Estafas',
    subtitle: 'Tu escudo contra los cazaturistas',
    content: 'Las 10 estafas más comunes en Londres, la psicología del estafador, frases de bloqueo con nivel de intensidad, zonas de mayor riesgo, modales británicos obligatorios, tips de ahorro y cómo comprar sin que te pasen por arriba.'
  }];
  const colorStyles = {
    blue: 'from-blue-500/20 to-blue-900/20 border-blue-500/30 text-blue-400',
    green: 'from-green-500/20 to-green-900/20 border-green-500/30 text-green-400',
    orange: 'from-orange-500/20 to-orange-900/20 border-orange-500/30 text-orange-400',
    red: 'from-red-500/20 to-red-900/20 border-red-500/30 text-red-400'
  };
  const checklist = ['Frases listas para usar desde el primer día', 'Fonética criolla para pronunciar sin estudiar', 'Tablas de vocabulario por situación', 'Frases de emergencia memorizables', 'Worksheet de práctica', 'Checklist final por tomo', '100% pensado para el viajero argentino'];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-900" data-id="element-354">
      <div className="max-w-6xl mx-auto" data-id="element-355">
        <div className="text-center mb-16" data-id="element-356">
          <h2 className="text-3xl md:text-5xl font-bold mb-4 flex items-center justify-center gap-3" data-id="element-357">
            <span className="text-2xl" data-id="element-358">🇬🇧</span> LOS 4 TOMOS COMPLETOS
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-359">
          {tomos.map((tomo, i) => <motion.div key={tomo.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-gradient-to-br ${colorStyles[tomo.color as keyof typeof colorStyles].split(' ').slice(0, 2).join(' ')} border ${colorStyles[tomo.color as keyof typeof colorStyles].split(' ')[2]} rounded-2xl p-8 relative overflow-hidden`} data-id="element-360">
              <div className="absolute top-0 right-0 p-6 opacity-10" data-id="element-361">
                <Book className="w-32 h-32" data-id="element-362" />
              </div>

              <div className="relative z-10" data-id="element-363">
                <div className={`inline-flex items-center gap-2 px-3 py-1 rounded-full bg-slate-900/50 border border-slate-700/50 text-sm font-bold mb-4 ${colorStyles[tomo.color as keyof typeof colorStyles].split(' ')[3]}`} data-id="element-364">
                  <Book className="w-4 h-4" data-id="element-365" /> Tomo {tomo.id}
                </div>
                <h3 className="text-2xl font-bold text-white mb-2" data-id="element-366">
                  {tomo.title}
                </h3>
                <p className={`font-semibold mb-6 ${colorStyles[tomo.color as keyof typeof colorStyles].split(' ')[3]}`} data-id="element-367">
                  {tomo.subtitle}
                </p>
                <p className="text-slate-300 leading-relaxed" data-id="element-368">{tomo.content}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto glass-panel rounded-2xl p-8 md:p-10" data-id="element-369">
          <h3 className="text-2xl font-bold text-center mb-8 text-white" data-id="element-370">
            Cada tomo incluye:
          </h3>
          <div className="grid sm:grid-cols-2 gap-4" data-id="element-371">
            {checklist.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-372">
                <CheckCircle2 className="w-6 h-6 text-green-400 shrink-0" data-id="element-373" />
                <span className="text-slate-300 font-medium" data-id="element-374">{item}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}